import { StepsId } from './types';
export const DEFAULT_STEPS = [
    {
        id: StepsId.SelectProject,
        text: 'select_a_project'
    },
    {
        id: StepsId.LoadResources,
        text: 'choose_a_method'
    },
    {
        id: StepsId.PlanTeam,
        text: 'plan_your_team'
    }
];
